import styled from 'styled-components';

export const Container = styled.div`
    font-family: Arial;
    background-color: #F48C06;
    width: 100%;
    height: 100vh;
`;
    
export const Header = styled.div`
    background-color: #191919;
    height: 150px;
    text-align: center;
    display: flex;
    justify-content: center;
`;

export const HeaderText = styled.h1`
    margin: 0;
    padding: 0;
    color: #FFF;
    padding-top: 30px;
`;

export const Body = styled.div`
    margin: auto;
    max-width: 980px;
    margin-bottom: 50px;
`;